import dataStore from '../../../data/data';

export function castVitruvian() {
  const data = dataStore.getState();
  const mesh = data.mediaprocessing?.vitruvian?.face?.facemesh;
  const landmarks = data.mediaprocessing?.vitruvian?.face?.cast?.landmarks?.live;

  if (!mesh || !landmarks?.length) return;

  const attr = mesh.geometry.attributes.position;

  const pivot = landmarks[1];
  if (!pivot) return;

  for (let i = 0; i < attr.count; i++) {
    const p = landmarks[i];
    if (!p) continue;

    attr.setXYZ(
      i,
      (p.x) * 3,
      -p.y * 3,
      -(p.z) * 3
    );
  }

  attr.needsUpdate = true;
}

export function castPeer() {
  const data = dataStore.getState();
  const mesh = data.mediaprocessing?.peer?.face?.facemesh;
  const landmarks = data.mediaprocessing?.peer?.face?.cast?.landmarks?.live;

  if (!mesh || !landmarks?.length) return;

  const attr = mesh.geometry.attributes.position;

  const pivot = landmarks[1];
  if (!pivot) return;

  for (let i = 0; i < attr.count; i++) {
    const p = landmarks[i];
    if (!p) continue;

    attr.setXYZ(
      i,
      (p.x) * 3,
      -p.y * 3,
      -(p.z) * 3
    );
  }

  attr.needsUpdate = true;
}